import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { Alert, Button, FormGroup, Label } from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import { pendingConfiguration } from '../../Materials/readiness'

const PricingShippingMaterials = ({ codes, onChange, onAvailable, selectedMaterial }) => {
    const [materials, setMaterials] = useState([])
    const [pending, setPending] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    useEffect(() => {
        let mounted = true
        const load = async () => {
            try {
                const response = await ApiService.getMaterials()
                const items = response.data.materials
                if (!Array.isArray(items)) throw new Error('Missing materials catalog')
                if (!mounted) return
                setMaterials(items)
                onAvailable(items)
                const states = await Promise.all(items.map(async item => {
                    let configuration
                    if (item.readiness && (!item.readiness.hasPrices || !item.readiness.hasShippingProfiles)) {
                        try { configuration = (await ApiService.getMaterialConfiguration(item.id)).data }
                        catch (_) { return null }
                    }
                    return pendingConfiguration(item, configuration)
                }))
                if (mounted) setPending(states.includes(null) ? null : items.filter((_, index) => states[index]).map(item => item.code))
            } catch (_) {
                if (mounted) { setError('No pude cargar los materiales. Vuelve a abrir esta sección para reintentar.'); onAvailable([]) }
            } finally { if (mounted) setLoading(false) }
        }
        load()
        return () => { mounted = false }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    // Keep navigation context visible even if that code is no longer in the catalog;
    // the API remains the authority for validating selected codes on export.
    const options = materials.map(item => ({ value: item.code, label: `${item.name} (${item.code})` }))
    const selected = (codes || []).map(code => options.find(option => option.value === code) || { value: code, label: code })
    return <FormGroup>
        <Label for="pricing-export-materials">Materiales ({selected.length} seleccionados)</Label>
        <Select inputId="pricing-export-materials" instanceId="pricing-export-materials" isMulti isSearchable isClearable
            options={options} value={selected} isLoading={loading} isDisabled={loading || Boolean(error)}
            onChange={values => onChange((values || []).map(option => option.value))}
            placeholder="Buscar por nombre o código…" noOptionsMessage={() => 'Sin coincidencias'} />
        <div className="mt-2">
            <Button size="sm" color="link" disabled={loading || Boolean(error)} onClick={() => onChange(materials.map(item => item.code))}>Todos</Button>
            <Button size="sm" color="link" disabled={loading || Boolean(error)} onClick={() => onChange(materials.filter(item => !item.isActive).map(item => item.code))}>Solo borradores</Button>
            <Button size="sm" color="link" disabled={loading || pending === null} onClick={() => onChange(pending)}>Pendientes de configurar</Button>
            <Button size="sm" color="link" disabled={!selected.length} onClick={() => onChange([])}>Limpiar selección</Button>
        </div>
        {selectedMaterial && <small className="text-muted d-block">Material de origen: {selectedMaterial}. Puedes modificar la selección de exportación.</small>}
        {!loading && !error && pending === null && <small className="text-warning d-block">No se pudieron identificar los pendientes: falta información de configuración. Consulta Materiales.</small>}
        {error && <Alert color="danger" role="alert">{error}</Alert>}
    </FormGroup>
}
export default PricingShippingMaterials
